import { createSlice } from '@reduxjs/toolkit'
import { postRequest } from '../../services/apiCaller/cl_index'
import { endpoints } from '../../api/ApiEndPoints'
import { getFromLocalStorage } from '../../services/helper/cl_Helper'
import { setSessionActive } from '../signIn/cl_SignInSlice'
import { handleLogout } from '../changePin/cl_ChangePinSlice'

const initialState = {
  betHistoryData: [],
  totalRecords: 0,
  records: 0,
  loader: false,
  casinoHistory: [],
  casinoTotalRecords: 0,
  casinoRecords: 0,
  casinoRoundData: {}
}
export const betHistorySlice = createSlice({
  name: 'betHistory',
  initialState,
  reducers: {
    setBetHistoryData: (state, action) => {
      state.betHistoryData = action.payload
    },
    setTotalRecords: (state, action) => {
      state.totalRecords = action.payload;
    },
    setRecords: (state, action) => {
      state.records = action.payload;
    },
    setLoader: (state, action) => {
      state.loader = action.payload;
    },
    setCasinoHistory: (state, action) => {
      state.casinoHistory = action.payload
    },
    setCasinoTotalRecords: (state, action) => {
      state.casinoTotalRecords = action.payload;
    },
    setCasinoRecords: (state, action) => {
      state.casinoRecords = action.payload;
    },
    setCasinoRoundData: (state, action) => {
      const { roundId, data } = action.payload;
      state.casinoRoundData[roundId] = data;
    }
  }
})

export const { setBetHistoryData, setTotalRecords, setRecords, setLoader, setCasinoHistory, setCasinoTotalRecords, setCasinoRecords, setCasinoRoundData } = betHistorySlice.actions

export default betHistorySlice.reducer

export const fetchBetHistory = (pageNum) => dispatch => {
  dispatch(setLoader(true))
  const token = getFromLocalStorage('gk')
  let url = `${endpoints.betHistory}`
  const payload = {
    accessToken: token,
    itemPerPage: 10,
    pageNumber: pageNum,
  }
  postRequest(url, payload).then(res => {
    if (res?.status === 200) {
      dispatch(setBetHistoryData(res?.data?.result?.data?.data))
      dispatch(setTotalRecords(res?.data?.result?.data?.totalRecords))
      dispatch(setLoader(false))
    } else {
      console.log(res?.data?.result?.message);
      dispatch(setLoader(false));
    }
    if (res?.data?.result?.status == 401) {
      dispatch(handleLogout(token))
    }
  })
}

// export const fetchCasinoHistory = (data, token, pageNum) => dispatch => {
//   let url = `${endpoints.betHistory}`
//   const payload = {
//     accessToken: token,
//     gameType: 'CASINO',
//     itemPerPage: 2,
//     pageNumber: pageNum,
//   }
//   postRequest(url, payload).then(res => {
//     if (res?.status === 200) {
//       const mergedArray = [
//         ...data?.result?.data?.data,
//         ...res?.data?.result?.data?.data
//       ]
//       if (mergedArray.length > 0) {
//         mergedArray.sort(
//           (a, b) => new Date(a.placedDate) - new Date(b.placedDate)
//         )
//         dispatch(setBetHistoryData(mergedArray))
//         dispatch(setRecords(res?.data?.result?.data?.totalRecords))
//       } else {
//         dispatch(setBetHistoryData([]))
//       }
//     }
//   })
// }

export const fetchCasinoHistoryData = (pageNum) => dispatch => {
  dispatch(setLoader(true))
  const token = getFromLocalStorage('gk')
  let url = `${endpoints.casinoHistory}`
  const payload = {
    accessToken: token,
    itemPerPage: 10,
    pageNumber: pageNum,
  }
  postRequest(url, payload).then(res => {
    if (res?.status === 200) {
      dispatch(setCasinoHistory(res?.data?.result?.data?.data))
      dispatch(setCasinoTotalRecords(res?.data?.result?.data?.totalRecords))
      dispatch(setLoader(false))
    } else {
      console.log(res?.data?.result?.message);
      dispatch(setLoader(false));
    }
    if (res?.data?.result?.status == 401) {
      dispatch(handleLogout(token))
    }
  })
}

export const fetchBetHistoryRoundData = (roundId) => (dispatch) => {
  const token = getFromLocalStorage('gk');
  let url = `${endpoints.casinoRoundHistory}`;
  const payload = { accessToken: token, roundId };

  return postRequest(url, payload).then(res => {
    if (res?.status === 200) {
      const data = res?.data?.result?.data?.data || [];
      dispatch(setCasinoRoundData({ roundId, data }));
      return data;
    } else if (res?.data?.result?.status == 401) {
      dispatch(handleLogout(token));
    } else {
      console.log(res?.data?.result?.message);
      return [];
    }
  });
};


